export const workMessages = {
  en: {
    sync: { title: 'Feishu sync', notConnected: 'No Feishu source is connected. A platform administrator who leads this company connects it under Manage guild → Task trees.', connected: 'Connected to Feishu (tree {slug}). Edits on either side sync automatically about every 5 minutes.', lastSynced: 'Last synced {time}', neverSynced: 'Not synced yet', conflicts: '{n} item(s) need a decision. Open the task to choose.', explanation: 'Edits in Feishu enter this task automatically; platform progress, status and delivery are written back to the Feishu table.', conflict: 'Conflicting changes require the publisher', platform: 'Platform version', remote: 'Feishu version', keepPlatform: 'Keep platform result', useFeishu: 'Use Feishu result', sourceDeleted: 'This row was deleted in Feishu. The task is kept because it has an owner, delivery or funds; the publisher decides what to do.', status: { pending: 'Waiting to sync', synced: 'Synced', conflict: 'Needs a decision', paused: 'Paused' }, fields: { percent: 'Both sides changed the progress', acceptance_changed_during_review: 'The acceptance criteria changed while in review', bounty_acceptance_needs_publisher: 'Feishu marks a bounty task 100%; the publisher must confirm payment', paid_acceptance_cannot_be_reversed: 'A paid acceptance cannot be reversed', paid_recipient_cannot_change: 'The recipient of a paid task cannot change', stale_acceptance: '100% belongs to an older assignment or revision' } },
    table: { title: 'Task list', subtitle: 'Every task of the current guild. Click a column header to sort; click a row to see and edit it on the right.', search: 'Search title or node', status: 'Status', source: 'Source', node: 'Node', progress: 'Progress', due: 'Due', updated: 'Updated', ownerAll: 'All owners', ownerMe: 'Mine', sourceAll: 'All sources', sourceTree: 'OKR tree (Feishu)', sourceOther: 'Other tasks', total: '{from}–{to} of {n}', prev: 'Previous', next: 'Next', detail: 'Task details', openFull: 'Open full page (submit, review, history)', cancel: 'Cancel', delete: 'Delete', deleteConfirm: 'Delete (revoke) "{title}"? Escrowed funds are refunded.', working: 'Working…', report: 'Report' },
    history: 'Assignment and activity history',
    abandon: 'Give up and reopen',
    title: 'My work',
    subtitle: 'You own the task. Work yourself or delegate to your Agents.',
    edit: 'Edit',
    save: 'Save changes',
    allStatuses: 'All statuses',
    sortReward: 'Highest reward',
    newTask: 'Publish work',
    newChild: 'Decompose task',
    refresh: 'Refresh',
    chooseGuild: 'Choose a company in the header.',
    personalWallet: 'Personal wallet',
    available: 'Available',
    held: 'In escrow',
    claimKr: 'Claim a key result',
    chooseKr: 'Choose a KR',
    claim: 'Claim',
    taskTitle: 'Task title',
    description: 'Description',
    acceptance: 'Acceptance criteria, one per line',
    owner: 'Responsible person',
    publisher: 'Publisher / reviewer',
    reward: 'Reward (zero is allowed)',
    funding: 'Funding source',
    guildBank: 'Company treasury',
    publish: 'Publish',
    dismiss: 'Dismiss',
    mine: 'My tasks and reviews',
    allRoots: 'Company tasks',
    empty: 'No tasks yet.',
    more: 'Load more',
    parent: 'Parent task',
    unassigned: 'Open for claiming',
    assign: 'Assign immediately',
    release: 'Take back / reopen',
    cancelTask: 'Revoke this task',
    executor: 'Execution',
    byPerson: 'I will do it',
    delegate: 'Set executor',
    result: 'Work result',
    link: 'Result link (HTTPS)',
    file: 'Result file',
    filesAdded: '{n} files attached',
    submit: 'Submit for review',
    rejectionReason: 'Revision reason',
    accept: 'Accept',
    reject: 'Return for revision',
    remind: 'Remind reviewer',
    escalate: 'Escalate to company lead',
    children: 'Subtasks',
    independentChildren: 'Children keep their own reviews and rewards after this task closes.',
    submissions: 'Submitted results',
    reviews: 'Review history',
    round: 'Round {n}',
    notifications: 'Work notifications',
    status: {
      open: 'Open',
      claimed: 'In progress',
      submitted: 'Awaiting review',
      rework: 'Needs revision',
      settled: 'Accepted',
      cancelled: 'Revoked',
    },
    activity: {
      sync_bind: 'Feishu sync',
      sync_create: 'Created from Feishu',
      sync_source_deleted: 'Deleted in Feishu',
      sync_import: 'Import from Feishu',
      sync_conflict: 'Conflicting changes require the publisher',
      sync_resolve: 'Use Feishu result',
      sync_pause: 'Pause sync',
      sync_resume: 'Retry / resume',

      created: 'Publish',
      claim: 'Claim',
      assign: 'Assign immediately',
      release: 'Take back / reopen',
      delegate: 'Set executor',
      submit: 'Submit for review',
      accept: 'Accept',
      reject: 'Return for revision',
      cancel: 'Revoke this task',
      edit: 'Edited task',
      remind: 'Remind reviewer',
      escalate: 'Escalate to company lead',
      external_accept: 'Accept',
    },
  },
  zh: {
    sync: { title: '飞书同步', notConnected: '尚未连接飞书来源。由本公司的平台管理员在「管理公会 → 任务树」连接。', connected: '已连接飞书（树 {slug}）。两边的修改约每 5 分钟自动同步一轮。', lastSynced: '上次同步 {time}', neverSynced: '尚未同步', conflicts: '有 {n} 项需要决定，请打开任务选择。', explanation: '飞书里的修改会自动进入任务；平台的进度、状态和交付会自动写回飞书表。', conflict: '双方变更冲突，需发布者选择', platform: '平台版本', remote: '飞书版本', keepPlatform: '保留平台结果', useFeishu: '采用飞书结果', sourceDeleted: '这一行已在飞书删除。因为任务已有负责人、交付或资金而保留，由发布者决定如何处理。', status: { pending: '等待同步', synced: '已同步', conflict: '待上级选择', paused: '已暂停' }, fields: { percent: '两边都改了进度', acceptance_changed_during_review: '评审期间验收标准被改动', bounty_acceptance_needs_publisher: '飞书把有奖金的任务标为 100%，须发布者确认付款', paid_acceptance_cannot_be_reversed: '已付款验收不能撤回', paid_recipient_cannot_change: '已付款任务不能更换收款人', stale_acceptance: '100% 属于旧分配或旧交付版本' } },
    table: { title: '任务列表', subtitle: '当前公会的全部任务。点表头排序，点一行在右侧查看和修改。', search: '搜索标题或节点', status: '状态', source: '来源', node: '节点', progress: '进度', due: '截止', updated: '更新', ownerAll: '全部负责人', ownerMe: '我的', sourceAll: '全部来源', sourceTree: 'OKR 树（飞书）', sourceOther: '其他任务', total: '第 {from}–{to} 条，共 {n} 条', prev: '上一页', next: '下一页', detail: '任务详情', openFull: '打开完整页（提交、评审、历史）', cancel: '取消', delete: '删除', deleteConfirm: '删除（撤销）「{title}」？已托管的奖金会退回。', working: '处理中…', report: '汇报' },
    history: '分工与操作记录',
    abandon: '放弃并放回领取',
    title: '我的工作',
    subtitle: '任务归你负责，可亲自完成或交给自己的 Agent。',
    edit: '修改',
    save: '保存修改',
    allStatuses: '全部状态',
    sortReward: '赏金最高',
    newTask: '发布工作',
    newChild: '分解子任务',
    refresh: '刷新',
    chooseGuild: '请先在顶栏选择公司。',
    personalWallet: '个人钱包',
    available: '可用',
    held: '托管中',
    claimKr: '领取 KR',
    chooseKr: '选择 KR',
    claim: '领取',
    taskTitle: '任务标题',
    description: '说明',
    acceptance: '验收标准，每行一条',
    owner: '责任人',
    publisher: '发布者 / 审核人',
    reward: '奖金（允许为零）',
    funding: '资金来源',
    guildBank: '公司金库',
    publish: '发布',
    dismiss: '收起',
    mine: '我的任务与审核',
    allRoots: '公司任务',
    empty: '暂无任务。',
    more: '加载更多',
    parent: '上级任务',
    unassigned: '开放领取',
    assign: '立即指派',
    release: '夺回 / 放回领取',
    cancelTask: '撤销当前任务',
    executor: '执行方式',
    byPerson: '由我亲自完成',
    delegate: '设置执行者',
    result: '工作成果',
    link: '成果链接（HTTPS）',
    file: '成果文件',
    filesAdded: '已附加 {n} 个文件',
    submit: '提交审核',
    rejectionReason: '打回原因',
    accept: '通过',
    reject: '打回返工',
    remind: '提醒上级审核',
    escalate: '升级给公会负责人',
    children: '子任务',
    independentChildren: '本任务关闭后，子任务继续独立审核和领赏。',
    submissions: '历次交付',
    reviews: '审核记录',
    round: '第 {n} 轮',
    notifications: '工作通知',
    status: {
      open: '待领取',
      claimed: '进行中',
      submitted: '待审核',
      rework: '待返工',
      settled: '已通过',
      cancelled: '已撤销',
    },
    activity: {
      sync_bind: '飞书同步',
      sync_create: '由飞书创建',
      sync_source_deleted: '飞书已删除',
      sync_import: '从飞书同步',
      sync_conflict: '双方变更冲突，需发布者选择',
      sync_resolve: '采用飞书结果',
      sync_pause: '暂停同步',
      sync_resume: '重试 / 恢复同步',

      created: '发布',
      claim: '领取',
      assign: '立即指派',
      release: '夺回 / 放回领取',
      delegate: '设置执行者',
      submit: '提交审核',
      accept: '通过',
      reject: '打回返工',
      cancel: '撤销当前任务',
      edit: '修改了任务',
      remind: '提醒上级审核',
      escalate: '升级给公会负责人',
      external_accept: '通过',
    },
  },
  ja: {
    sync: { title: 'Feishu 同期', notConnected: 'Feishu の元データが未接続です。この会社のプラットフォーム管理者が「ギルド管理 → タスクツリー」で接続します。', connected: 'Feishu に接続済み（ツリー {slug}）。どちらの編集も約5分ごとに自動で同期されます。', lastSynced: '最終同期 {time}', neverSynced: '未同期', conflicts: '{n} 件の判断が必要です。タスクを開いて選んでください。', explanation: 'Feishu の編集は自動でこのタスクに反映され、プラットフォームの進捗・状態・成果物は Feishu 表へ書き戻されます。', conflict: '競合には発行者の判断が必要です', platform: 'プラットフォーム版', remote: 'Feishu 版', keepPlatform: 'プラットフォームを維持', useFeishu: 'Feishu を採用', sourceDeleted: 'この行は Feishu で削除されました。担当者・成果物・資金があるためタスクは残し、発行者が対応を決めます。', status: { pending: '同期待ち', synced: '同期済み', conflict: '判断待ち', paused: '停止中' }, fields: { percent: '両側で進捗が変更されました', acceptance_changed_during_review: 'レビュー中に受入基準が変更されました', bounty_acceptance_needs_publisher: 'Feishu が報酬付きタスクを100%にしました。発行者の支払い確認が必要です', paid_acceptance_cannot_be_reversed: '支払済みの承認は取消不可', paid_recipient_cannot_change: '支払済みタスクの受取人は変更できません', stale_acceptance: '旧担当または旧成果の100%' } },
    table: { title: 'タスク一覧', subtitle: '現在のギルドの全タスク。見出しで並べ替え、行をクリックすると右側で確認・編集できます。', search: 'タイトルまたはノードを検索', status: '状態', source: '出所', node: 'ノード', progress: '進捗', due: '期限', updated: '更新', ownerAll: '全担当者', ownerMe: '自分', sourceAll: '全ての出所', sourceTree: 'OKR ツリー（Feishu）', sourceOther: 'その他のタスク', total: '{from}–{to} / {n} 件', prev: '前へ', next: '次へ', detail: 'タスクの詳細', openFull: '詳細ページを開く（提出・レビュー・履歴）', cancel: 'キャンセル', delete: '削除', deleteConfirm: '「{title}」を削除（取消）しますか？託管済みの報酬は返金されます。', working: '処理中…', report: '報告' },
    history: '担当と操作の履歴',
    abandon: '辞退して再募集',
    title: '自分の仕事',
    subtitle: '自分で実行するか、自分のエージェントに委任できます。',
    edit: '編集',
    save: '変更を保存',
    allStatuses: 'すべての状態',
    sortReward: '報酬が高い順',
    newTask: '仕事を公開',
    newChild: '子タスクを作成',
    refresh: '更新',
    chooseGuild: '上部で会社を選択してください。',
    personalWallet: '個人ウォレット',
    available: '利用可能',
    held: '預託中',
    claimKr: '主要成果を引き受ける',
    chooseKr: 'KR を選択',
    claim: '引き受ける',
    taskTitle: 'タスク名',
    description: '説明',
    acceptance: '受入基準（1行に1項目）',
    owner: '責任者',
    publisher: '公開者・審査担当',
    reward: '報酬（0可）',
    funding: '支払元',
    guildBank: '会社の金庫',
    publish: '公開',
    dismiss: '閉じる',
    mine: '自分のタスクと審査',
    allRoots: '会社のタスク',
    empty: 'タスクはまだありません。',
    more: 'さらに表示',
    parent: '親タスク',
    unassigned: '担当者募集中',
    assign: 'すぐに割り当て',
    release: '取り戻す・再募集',
    cancelTask: 'このタスクを取り消す',
    executor: '実行方法',
    byPerson: '自分で実行',
    delegate: '実行担当を設定',
    result: '成果',
    link: '成果リンク（HTTPS）',
    file: '成果ファイル',
    filesAdded: '添付 {n} 件',
    submit: '審査に提出',
    rejectionReason: '差し戻し理由',
    accept: '承認',
    reject: '差し戻す',
    remind: '審査担当に通知',
    escalate: '責任者へ相談',
    children: '子タスク',
    independentChildren: '親の完了後も子タスクは独立して審査・支払いされます。',
    submissions: '提出履歴',
    reviews: '審査履歴',
    round: '第 {n} 回',
    notifications: '仕事の通知',
    status: {
      open: '募集中',
      claimed: '作業中',
      submitted: '審査待ち',
      rework: '修正待ち',
      settled: '承認済み',
      cancelled: '取消済み',
    },
    activity: {
      sync_bind: 'Feishu 同期',
      sync_create: 'Feishu から作成',
      sync_source_deleted: 'Feishu で削除',
      sync_import: 'Feishu から取り込む',
      sync_conflict: '競合には発行者の判断が必要です',
      sync_resolve: 'Feishu を採用',
      sync_pause: '同期を停止',
      sync_resume: '再試行・再開',

      created: '公開',
      claim: '引き受ける',
      assign: 'すぐに割り当て',
      release: '取り戻す・再募集',
      delegate: '実行担当を設定',
      submit: '審査に提出',
      accept: '承認',
      reject: '差し戻す',
      cancel: 'このタスクを取り消す',
      edit: 'タスクを編集',
      remind: '審査担当に通知',
      escalate: '責任者へ相談',
      external_accept: '承認',
    },
  },
  es: {
    sync: { title: 'Sincronización con Feishu', notConnected: 'No hay una fuente de Feishu conectada. Un administrador de plataforma de esta empresa la conecta en Gestionar gremio → Árboles de tareas.', connected: 'Conectado a Feishu (árbol {slug}). Los cambios de ambos lados se sincronizan automáticamente cada ~5 minutos.', lastSynced: 'Última sincronización {time}', neverSynced: 'Aún sin sincronizar', conflicts: '{n} elemento(s) requieren una decisión. Abre la tarea para elegir.', explanation: 'Los cambios en Feishu entran solos en esta tarea; el avance, el estado y la entrega de la plataforma se escriben en la tabla de Feishu.', conflict: 'El publicador debe resolver el conflicto', platform: 'Versión de plataforma', remote: 'Versión de Feishu', keepPlatform: 'Conservar plataforma', useFeishu: 'Usar Feishu', sourceDeleted: 'Esta fila se eliminó en Feishu. La tarea se conserva porque tiene responsable, entrega o fondos; el publicador decide.', status: { pending: 'Pendiente', synced: 'Sincronizado', conflict: 'Requiere decisión', paused: 'En pausa' }, fields: { percent: 'Ambos lados cambiaron el avance', acceptance_changed_during_review: 'Los criterios cambiaron durante la revisión', bounty_acceptance_needs_publisher: 'Feishu marca al 100% una tarea con recompensa; el publicador debe confirmar el pago', paid_acceptance_cannot_be_reversed: 'No se puede revertir un pago aceptado', paid_recipient_cannot_change: 'No se puede cambiar al receptor de una tarea pagada', stale_acceptance: 'El 100% corresponde a una asignación anterior' } },
    table: { title: 'Lista de tareas', subtitle: 'Todas las tareas del gremio actual. Pulsa un encabezado para ordenar y una fila para verla y editarla a la derecha.', search: 'Buscar título o nodo', status: 'Estado', source: 'Origen', node: 'Nodo', progress: 'Avance', due: 'Vence', updated: 'Actualizado', ownerAll: 'Todos los responsables', ownerMe: 'Mías', sourceAll: 'Todos los orígenes', sourceTree: 'Árbol OKR (Feishu)', sourceOther: 'Otras tareas', total: '{from}–{to} de {n}', prev: 'Anterior', next: 'Siguiente', detail: 'Detalle de la tarea', openFull: 'Abrir la página completa (entrega, revisión, historial)', cancel: 'Cancelar', delete: 'Eliminar', deleteConfirm: '¿Eliminar (revocar) «{title}»? Los fondos en custodia se devuelven.', working: 'Procesando…', report: 'Informar' },
    history: 'Historial de asignaciones y actividad',
    abandon: 'Renunciar y reabrir',
    title: 'Mi trabajo',
    subtitle: 'Trabaja personalmente o delega en tus agentes.',
    edit: 'Editar',
    save: 'Guardar cambios',
    allStatuses: 'Todos los estados',
    sortReward: 'Mayor recompensa',
    newTask: 'Publicar trabajo',
    newChild: 'Crear subtarea',
    refresh: 'Actualizar',
    chooseGuild: 'Selecciona una empresa arriba.',
    personalWallet: 'Cartera personal',
    available: 'Disponible',
    held: 'En depósito',
    claimKr: 'Asumir resultado clave',
    chooseKr: 'Seleccionar KR',
    claim: 'Asumir',
    taskTitle: 'Título',
    description: 'Descripción',
    acceptance: 'Criterios, uno por línea',
    owner: 'Responsable',
    publisher: 'Publicador / revisor',
    reward: 'Recompensa (puede ser cero)',
    funding: 'Origen de fondos',
    guildBank: 'Tesorería',
    publish: 'Publicar',
    dismiss: 'Cerrar',
    mine: 'Mis tareas y revisiones',
    allRoots: 'Tareas de empresa',
    empty: 'Sin tareas.',
    more: 'Cargar más',
    parent: 'Tarea superior',
    unassigned: 'Disponible',
    assign: 'Asignar ahora',
    release: 'Recuperar / reabrir',
    cancelTask: 'Revocar esta tarea',
    executor: 'Ejecución',
    byPerson: 'Lo hago yo',
    delegate: 'Definir ejecutor',
    result: 'Resultado',
    link: 'Enlace (HTTPS)',
    file: 'Archivo',
    filesAdded: '{n} archivos adjuntos',
    submit: 'Enviar a revisión',
    rejectionReason: 'Motivo de revisión',
    accept: 'Aceptar',
    reject: 'Devolver para revisión',
    remind: 'Recordar al revisor',
    escalate: 'Escalar al responsable',
    children: 'Subtareas',
    independentChildren: 'Las subtareas conservan revisión y recompensa propias.',
    submissions: 'Entregas',
    reviews: 'Historial de revisión',
    round: 'Ronda {n}',
    notifications: 'Notificaciones',
    status: {
      open: 'Disponible',
      claimed: 'En curso',
      submitted: 'En revisión',
      rework: 'Requiere revisión',
      settled: 'Aceptado',
      cancelled: 'Revocado',
    },
    activity: {
      sync_bind: 'Sincronización con Feishu',
      sync_create: 'Creada desde Feishu',
      sync_source_deleted: 'Eliminada en Feishu',
      sync_import: 'Importar de Feishu',
      sync_conflict: 'El publicador debe resolver el conflicto',
      sync_resolve: 'Usar Feishu',
      sync_pause: 'Pausar',
      sync_resume: 'Reintentar / reanudar',

      created: 'Publicar',
      claim: 'Asumir',
      assign: 'Asignar ahora',
      release: 'Recuperar / reabrir',
      delegate: 'Definir ejecutor',
      submit: 'Enviar a revisión',
      accept: 'Aceptar',
      reject: 'Devolver para revisión',
      cancel: 'Revocar esta tarea',
      edit: 'Editó la tarea',
      remind: 'Recordar al revisor',
      escalate: 'Escalar al responsable',
      external_accept: 'Aceptar',
    },
  },
  id: {
    sync: { title: 'Sinkronisasi Feishu', notConnected: 'Belum ada sumber Feishu yang terhubung. Administrator platform perusahaan ini menghubungkannya di Kelola guild → Pohon tugas.', connected: 'Terhubung ke Feishu (pohon {slug}). Perubahan di kedua sisi tersinkron otomatis sekitar tiap 5 menit.', lastSynced: 'Sinkron terakhir {time}', neverSynced: 'Belum disinkronkan', conflicts: '{n} item perlu keputusan. Buka tugas untuk memilih.', explanation: 'Perubahan di Feishu masuk otomatis ke tugas ini; progres, status, dan hasil kerja platform ditulis kembali ke tabel Feishu.', conflict: 'Penerbit harus menyelesaikan konflik', platform: 'Versi platform', remote: 'Versi Feishu', keepPlatform: 'Pertahankan platform', useFeishu: 'Gunakan Feishu', sourceDeleted: 'Baris ini dihapus di Feishu. Tugas dipertahankan karena punya penanggung jawab, hasil kerja, atau dana; penerbit yang memutuskan.', status: { pending: 'Menunggu', synced: 'Tersinkron', conflict: 'Perlu keputusan', paused: 'Dijeda' }, fields: { percent: 'Kedua sisi mengubah progres', acceptance_changed_during_review: 'Kriteria penerimaan berubah saat ditinjau', bounty_acceptance_needs_publisher: 'Feishu menandai tugas berimbalan 100%; penerbit harus mengonfirmasi pembayaran', paid_acceptance_cannot_be_reversed: 'Pembayaran yang diterima tidak dapat dibatalkan', paid_recipient_cannot_change: 'Penerima tugas yang sudah dibayar tidak dapat diganti', stale_acceptance: '100% berasal dari penugasan lama' } },
    table: { title: 'Daftar tugas', subtitle: 'Semua tugas guild saat ini. Klik judul kolom untuk mengurutkan, klik baris untuk melihat dan mengubahnya di kanan.', search: 'Cari judul atau simpul', status: 'Status', source: 'Sumber', node: 'Simpul', progress: 'Progres', due: 'Tenggat', updated: 'Diperbarui', ownerAll: 'Semua penanggung jawab', ownerMe: 'Milik saya', sourceAll: 'Semua sumber', sourceTree: 'Pohon OKR (Feishu)', sourceOther: 'Tugas lain', total: '{from}–{to} dari {n}', prev: 'Sebelumnya', next: 'Berikutnya', detail: 'Detail tugas', openFull: 'Buka halaman penuh (kirim, tinjau, riwayat)', cancel: 'Batal', delete: 'Hapus', deleteConfirm: 'Hapus (cabut) "{title}"? Dana yang ditahan dikembalikan.', working: 'Memproses…', report: 'Laporkan' },
    history: 'Riwayat penugasan dan aktivitas',
    abandon: 'Lepaskan dan buka lagi',
    title: 'Pekerjaan saya',
    subtitle: 'Kerjakan sendiri atau delegasikan ke agenmu.',
    edit: 'Ubah',
    save: 'Simpan perubahan',
    allStatuses: 'Semua status',
    sortReward: 'Hadiah tertinggi',
    newTask: 'Terbitkan pekerjaan',
    newChild: 'Buat subtugas',
    refresh: 'Muat ulang',
    chooseGuild: 'Pilih perusahaan di bagian atas.',
    personalWallet: 'Dompet pribadi',
    available: 'Tersedia',
    held: 'Ditahan',
    claimKr: 'Ambil hasil utama',
    chooseKr: 'Pilih KR',
    claim: 'Ambil',
    taskTitle: 'Judul tugas',
    description: 'Deskripsi',
    acceptance: 'Kriteria, satu per baris',
    owner: 'Penanggung jawab',
    publisher: 'Penerbit / peninjau',
    reward: 'Imbalan (boleh nol)',
    funding: 'Sumber dana',
    guildBank: 'Kas perusahaan',
    publish: 'Terbitkan',
    dismiss: 'Tutup',
    mine: 'Tugas dan tinjauan saya',
    allRoots: 'Tugas perusahaan',
    empty: 'Belum ada tugas.',
    more: 'Muat lainnya',
    parent: 'Tugas induk',
    unassigned: 'Terbuka untuk diambil',
    assign: 'Tugaskan langsung',
    release: 'Ambil kembali / buka lagi',
    cancelTask: 'Batalkan tugas ini',
    executor: 'Pelaksanaan',
    byPerson: 'Saya kerjakan sendiri',
    delegate: 'Tetapkan pelaksana',
    result: 'Hasil pekerjaan',
    link: 'Tautan hasil (HTTPS)',
    file: 'Berkas hasil',
    filesAdded: '{n} berkas dilampirkan',
    submit: 'Ajukan untuk ditinjau',
    rejectionReason: 'Alasan revisi',
    accept: 'Terima',
    reject: 'Kembalikan untuk revisi',
    remind: 'Ingatkan peninjau',
    escalate: 'Eskalasi ke pemimpin',
    children: 'Subtugas',
    independentChildren: 'Subtugas tetap ditinjau dan dibayar secara mandiri.',
    submissions: 'Riwayat hasil',
    reviews: 'Riwayat tinjauan',
    round: 'Putaran {n}',
    notifications: 'Pemberitahuan pekerjaan',
    status: {
      open: 'Terbuka',
      claimed: 'Dikerjakan',
      submitted: 'Menunggu tinjauan',
      rework: 'Perlu revisi',
      settled: 'Diterima',
      cancelled: 'Dibatalkan',
    },
    activity: {
      sync_bind: 'Sinkronisasi Feishu',
      sync_create: 'Dibuat dari Feishu',
      sync_source_deleted: 'Dihapus di Feishu',
      sync_import: 'Impor dari Feishu',
      sync_conflict: 'Penerbit harus menyelesaikan konflik',
      sync_resolve: 'Gunakan Feishu',
      sync_pause: 'Jeda sinkronisasi',
      sync_resume: 'Coba lagi / lanjutkan',

      created: 'Terbitkan',
      claim: 'Ambil',
      assign: 'Tugaskan langsung',
      release: 'Ambil kembali / buka lagi',
      delegate: 'Tetapkan pelaksana',
      submit: 'Ajukan untuk ditinjau',
      accept: 'Terima',
      reject: 'Kembalikan untuk revisi',
      cancel: 'Batalkan tugas ini',
      edit: 'Mengubah tugas',
      remind: 'Ingatkan peninjau',
      escalate: 'Eskalasi ke pemimpin',
      external_accept: 'Terima',
    },
  },
  pt: {
    sync: { title: 'Sincronização Feishu', notConnected: 'Nenhuma origem do Feishu conectada. Um administrador da plataforma desta empresa a conecta em Gerenciar guilda → Árvores de tarefas.', connected: 'Conectado ao Feishu (árvore {slug}). Alterações dos dois lados sincronizam automaticamente a cada ~5 minutos.', lastSynced: 'Última sincronização {time}', neverSynced: 'Ainda não sincronizado', conflicts: '{n} item(ns) exigem decisão. Abra a tarefa para escolher.', explanation: 'Edições no Feishu entram sozinhas nesta tarefa; progresso, estado e entrega da plataforma são gravados na tabela do Feishu.', conflict: 'O publicador deve resolver o conflito', platform: 'Versão da plataforma', remote: 'Versão Feishu', keepPlatform: 'Manter plataforma', useFeishu: 'Usar Feishu', sourceDeleted: 'Esta linha foi excluída no Feishu. A tarefa foi mantida porque tem responsável, entrega ou fundos; o publicador decide.', status: { pending: 'Pendente', synced: 'Sincronizado', conflict: 'Exige decisão', paused: 'Em pausa' }, fields: { percent: 'Os dois lados alteraram o progresso', acceptance_changed_during_review: 'Os critérios mudaram durante a revisão', bounty_acceptance_needs_publisher: 'O Feishu marcou 100% uma tarefa com recompensa; o publicador deve confirmar o pagamento', paid_acceptance_cannot_be_reversed: 'Uma aceitação paga não pode ser revertida', paid_recipient_cannot_change: 'O destinatário de uma tarefa paga não pode mudar', stale_acceptance: '100% pertence a uma atribuição anterior' } },
    table: { title: 'Lista de tarefas', subtitle: 'Todas as tarefas da guilda atual. Clique no cabeçalho para ordenar e numa linha para ver e editar à direita.', search: 'Buscar título ou nó', status: 'Status', source: 'Origem', node: 'Nó', progress: 'Progresso', due: 'Prazo', updated: 'Atualizado', ownerAll: 'Todos os responsáveis', ownerMe: 'Minhas', sourceAll: 'Todas as origens', sourceTree: 'Árvore OKR (Feishu)', sourceOther: 'Outras tarefas', total: '{from}–{to} de {n}', prev: 'Anterior', next: 'Próxima', detail: 'Detalhes da tarefa', openFull: 'Abrir a página completa (entrega, revisão, histórico)', cancel: 'Cancelar', delete: 'Excluir', deleteConfirm: 'Excluir (revogar) "{title}"? Os fundos em custódia são devolvidos.', working: 'Processando…', report: 'Informar' },
    history: 'Histórico de atribuições e atividades',
    abandon: 'Desistir e reabrir',
    title: 'Meu trabalho',
    subtitle: 'Trabalhe pessoalmente ou delegue aos seus agentes.',
    edit: 'Editar',
    save: 'Salvar alterações',
    allStatuses: 'Todos os estados',
    sortReward: 'Maior recompensa',
    newTask: 'Publicar trabalho',
    newChild: 'Criar subtarefa',
    refresh: 'Atualizar',
    chooseGuild: 'Selecione uma empresa no topo.',
    personalWallet: 'Carteira pessoal',
    available: 'Disponível',
    held: 'Em custódia',
    claimKr: 'Assumir resultado-chave',
    chooseKr: 'Selecionar KR',
    claim: 'Assumir',
    taskTitle: 'Título',
    description: 'Descrição',
    acceptance: 'Critérios, um por linha',
    owner: 'Responsável',
    publisher: 'Publicador / revisor',
    reward: 'Recompensa (pode ser zero)',
    funding: 'Origem dos fundos',
    guildBank: 'Tesouraria',
    publish: 'Publicar',
    dismiss: 'Fechar',
    mine: 'Minhas tarefas e revisões',
    allRoots: 'Tarefas da empresa',
    empty: 'Nenhuma tarefa.',
    more: 'Carregar mais',
    parent: 'Tarefa superior',
    unassigned: 'Disponível',
    assign: 'Atribuir agora',
    release: 'Retomar / reabrir',
    cancelTask: 'Revogar esta tarefa',
    executor: 'Execução',
    byPerson: 'Eu faço pessoalmente',
    delegate: 'Definir executor',
    result: 'Resultado',
    link: 'Link do resultado (HTTPS)',
    file: 'Arquivo',
    filesAdded: '{n} arquivos anexados',
    submit: 'Enviar para revisão',
    rejectionReason: 'Motivo da revisão',
    accept: 'Aceitar',
    reject: 'Devolver para revisão',
    remind: 'Lembrar revisor',
    escalate: 'Escalar ao responsável',
    children: 'Subtarefas',
    independentChildren: 'Subtarefas mantêm revisão e recompensa independentes.',
    submissions: 'Entregas',
    reviews: 'Histórico de revisão',
    round: 'Rodada {n}',
    notifications: 'Notificações',
    status: {
      open: 'Disponível',
      claimed: 'Em andamento',
      submitted: 'Aguardando revisão',
      rework: 'Requer revisão',
      settled: 'Aceito',
      cancelled: 'Revogado',
    },
    activity: {
      sync_bind: 'Sincronização Feishu',
      sync_create: 'Criada a partir do Feishu',
      sync_source_deleted: 'Excluída no Feishu',
      sync_import: 'Importar do Feishu',
      sync_conflict: 'O publicador deve resolver o conflito',
      sync_resolve: 'Usar Feishu',
      sync_pause: 'Pausar',
      sync_resume: 'Repetir / retomar',

      created: 'Publicar',
      claim: 'Assumir',
      assign: 'Atribuir agora',
      release: 'Retomar / reabrir',
      delegate: 'Definir executor',
      submit: 'Enviar para revisão',
      accept: 'Aceitar',
      reject: 'Devolver para revisão',
      cancel: 'Revogar esta tarefa',
      edit: 'Editou a tarefa',
      remind: 'Lembrar revisor',
      escalate: 'Escalar ao responsável',
      external_accept: 'Aceitar',
    },
  },
}
